import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="copyright">&copy; 2025 Ainaeco. All rights reserved.</div>
      <div className="system-status">
        <span className="status-indicator-dot"></span>
        <span className="status-text">System online | Last update: March 08, 2025</span>
      </div>
    </footer>
  );
};

export default Footer;
